import React from "react"

const QuotationSummaryContext = React.createContext({})

const { Provider, Consumer } = QuotationSummaryContext

export { Provider, Consumer, QuotationSummaryContext }
